import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { Text } from "@pentabd/ui";

import { MultiFile } from "@components";

import {
  InitiatePromotionFormValidationDataType,
  SUPPORTING_DOCUMENT,
} from "@validations/HRM/promotion/initiatePromotionFormValidation";

export const SupportingDocument = ({ isDisabled }: { isDisabled: boolean }) => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
    setValue,
    control,
  } = useFormContext<InitiatePromotionFormValidationDataType>();

  return (
    <div>
      <div className="border-bottom pt-10 pb-8 mb-8">
        <Text weight="semibold" color="title" size="md">
          {t("INITIATE_PROMOTION.FORM.DOCUMENT.LABEL")}
        </Text>
      </div>

      <div className="row mb-8">
        <div className="col-lg-3">
          <Text weight="semibold" color="title" size="sm" component="p">
            {t("INITIATE_PROMOTION.FORM.DOCUMENT.UPLOAD")}
          </Text>
        </div>
        <div className="col-lg-7">
          <MultiFile
            id={SUPPORTING_DOCUMENT}
            control={control}
            setValue={setValue}
            register={register}
            errors={errors}
            disabled={isDisabled}
            fileDetails={["documentName", "date", "remarks", "memorialNo"]}
          />
        </div>
      </div>
    </div>
  );
};
